import React from "react";
import { motion } from "framer-motion";
import { MessageSquare, Phone, ShieldCheck, MapPin, Handshake } from "lucide-react";
import { SMS_HREF, TEL_HREF, PHONE_DISPLAY, reveal } from "./constants";
import { track } from "@/lib/analytics";

export function FinalCTA() {
  return (
    <section
      className="relative bg-[#0A0A0A] text-white overflow-hidden grain"
      data-testid="final-cta-section"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-8 py-16 sm:py-24">
        <motion.div {...reveal} className="text-center">
          <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.22em] text-[#5FBE1F] mb-5">
            <span className="w-6 h-px bg-[#5FBE1F]" />
            Last thing
            <span className="w-6 h-px bg-[#5FBE1F]" />
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.05] tracking-normal max-w-3xl mx-auto">
            Ready to get your gutters
            <br />
            <span className="text-[#5FBE1F]">done right?</span>
          </h2>
          <p className="mt-6 text-base sm:text-lg text-[#C9C9C9] leading-relaxed max-w-xl mx-auto">
            One text and Mike will reach out to schedule. No call centers, no
            sales pitch — just a neighbor with a ladder.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
            <a
              href={SMS_HREF}
              onClick={() => track("text_gutters_click", { location: "final_cta" })}
              className="inline-flex items-center justify-center gap-2 bg-[#5FBE1F] text-white font-bold text-base sm:text-lg px-7 py-5 rounded-sm shadow-sm hover:bg-[#4A9818] hover:-translate-y-0.5 transition-all duration-300"
              data-testid="final-cta-sms"
            >
              <MessageSquare className="w-5 h-5" />
              Text &ldquo;Gutters&rdquo; to {PHONE_DISPLAY}
            </a>
            <a
              href={TEL_HREF}
              onClick={() => track("phone_call_click", { location: "final_cta" })}
              className="inline-flex items-center justify-center gap-2 border-2 border-white/30 text-white font-bold px-7 py-5 rounded-sm hover:bg-white hover:text-black hover:border-white transition-all duration-300"
              data-testid="final-cta-call"
            >
              <Phone className="w-4 h-4" />
              Or call {PHONE_DISPLAY}
            </a>
          </div>

          <div className="mt-12 flex flex-wrap items-center justify-center gap-6 sm:gap-10 text-xs sm:text-sm text-[#C9C9C9] font-semibold uppercase tracking-[0.18em]">
            <div className="inline-flex items-center gap-2">
              <ShieldCheck className="w-4 h-4 text-[#5FBE1F]" />
              Insured
            </div>
            <div className="inline-flex items-center gap-2">
              <MapPin className="w-4 h-4 text-[#5FBE1F]" />
              Local
            </div>
            <div className="inline-flex items-center gap-2">
              <Handshake className="w-4 h-4 text-[#5FBE1F]" />
              Neighborly
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
